// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-columns-container {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  background-color: ghostwhite;
  width: 100%;
  padding-bottom: 4px;
  padding-top: 4px;

}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/WordColumnsContainer/WordColumnsContainer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,4BAA4B;EAC5B,WAAW;EACX,mBAAmB;EACnB,gBAAgB;;AAElB","sourcesContent":[".word-columns-container {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  background-color: ghostwhite;\n  width: 100%;\n  padding-bottom: 4px;\n  padding-top: 4px;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
